module.exports = __webpack_public_path__ + "img/9791160260205.23856688.jpg";